import React from 'react';
import { Explorer } from 'src/features/DA/components/templates/Explorer';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { DAKeyMetrics } from '../../features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const ExplorerPage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Campaign Explorer"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <Explorer />
    </PageModelLayout>
  );
};
